import {notifications} from "@mantine/notifications";
import {IconAlertTriangleFilled, IconCheck, IconX} from "@tabler/icons-react";

export function spawnSuccessNotif(message: string) {
	return notifications.show({
		message: message,
		color: "green",
		title: "Povedlo se!",
		icon: <IconCheck/>
	})
}

export function spawnErrorNotif(message: string) {
	return notifications.show({
		message: message,
		color: "red",
		title: "Chyba",
		icon: <IconX />
	})
}

export function getWarnIcon() {
	return <IconAlertTriangleFilled />
}